import React, { useEffect, useMemo, useState } from "react";
import { Switch, Input, Drawer, Form, Button, Image } from "antd";
import TextArea from "antd/es/input/TextArea";
import { requestWithImage } from "../../../functions/request";
import { uniKey, validData } from "../../../functions/functionsUtility";
import { toast } from "react-toastify";
import { Content } from "antd/es/layout/layout";

const URL_IMAGENS = `${process.env.REACT_APP_API_RB}/dossie/capitulos/`;

/**
 * Campo de imagem do capítulo: mostra a atual ou a recém-escolhida, e
 * permite trocar ou remover.
 */
function CampoImagem({ rotulo, proporcao, atual, arquivo, removida, onArquivo, onRemover, onDesfazer, chaveInput }) {
  const previa = useMemo(() => (arquivo ? URL.createObjectURL(arquivo) : null), [arquivo]);
  useEffect(() => () => previa && URL.revokeObjectURL(previa), [previa]);
  const src = previa || (!removida && atual ? URL_IMAGENS + atual : null);

  return (
    <Form.Item label={rotulo}>
      <Content style={{ display: "flex", gap: 6, flexDirection: "column", alignItems: "center" }}>
        {src && <Image src={src} style={{ aspectRatio: proporcao, borderRadius: 8, objectFit: "cover" }} width={"80%"} />}
        {previa && <span style={{ fontSize: 12, color: "#1677ff" }}>Nova imagem — será salva ao clicar em Salvar</span>}
        {removida && !previa && <span style={{ fontSize: 12, color: "#cc0000" }}>Imagem será removida ao salvar</span>}
        <Input key={chaveInput} onChange={(e) => onArquivo(e.target.files[0] || null)} type="file" accept="image/*" />
        {(previa || (atual && !removida)) && (
          <Button size="small" danger onClick={onRemover}>
            {previa ? "Descartar imagem escolhida" : "Remover imagem"}
          </Button>
        )}
        {removida && !previa && (
          <Button size="small" onClick={onDesfazer}>
            Manter imagem atual
          </Button>
        )}
      </Content>
    </Form.Item>
  );
}

function ModalDossieCapitulo(props) {
  const [capaImage, setCapaImage] = useState(null);
  const [thumbImage, setThumbImage] = useState(null);
  const [removerCapa, setRemoverCapa] = useState(false);
  const [removerThumb, setRemoverThumb] = useState(false);
  // Muda a cada abertura: recria os <input type="file">, que não têm como
  // ser limpos por estado.
  const [versaoInputs, setVersaoInputs] = useState(0);

  // A gaveta não é desmontada ao fechar. Sem este reset, o arquivo escolhido
  // num capítulo continuava guardado e era enviado de novo ao salvar o
  // próximo capítulo aberto — a mesma capa ia parar em todos.
  const capituloAberto = props.isAddOpen ? props?.contentModal?.dca_id ?? "novo" : null;
  useEffect(() => {
    setCapaImage(null);
    setThumbImage(null);
    setRemoverCapa(false);
    setRemoverThumb(false);
    setVersaoInputs((v) => v + 1);
  }, [capituloAberto]);

  const aoSalvar = () => {
    props.onRequestClose();
    props.setContentModal({});
    props.onSaved?.();
  };

  const saveData = async () => {
    const formData = new FormData();
    let dataAux = {
      dca_ativo: 0,
      dca_aberto: 0,
    };
    const canSave = await validData(props.contentModal, [
      "dca_nome",
      "dca_ordem",
    ]);
    if (!canSave) {
      toast.error("Preencha todos os campos obrigatórios! Campo: Nome, Ordem");
      return;
    }
    for (const key in props?.contentModal) {
      if (
        props?.contentModal[key] !== null &&
        props?.contentModal[key] !== undefined
      ) {
        dataAux[key] = props?.contentModal[key];
      }
    }
    dataAux.index = uniKey();
    const newData = JSON.stringify(dataAux);
    formData.append("newData", newData);
    if (capaImage !== null) {
      formData.append("dca_capa", capaImage);
    }
    if (thumbImage !== null) {
      formData.append("dca_thumb", thumbImage);
    }
    await requestWithImage("/dossie_capitulos/insertCapitulo", {
      method: "POST",
      body: formData,
    })
      .then((res) => {
        if (res?.err) throw res.err;
        toast.success("Capítulo salvo com sucesso!");
        aoSalvar();
      })
      .catch((err) => {
        console.log(err);
        toast.error("Erro ao Salvar Dossiê!");
      });
  };

  const updateData = async () => {
    const formData = new FormData();
    let dataAux = {
      dca_ativo: 0,
      dca_aberto: 0,
    };
    const canSave = await validData(props.contentModal, [
      "dca_nome",
      "dca_ordem",
    ]);
    if (!canSave) {
      toast.error(
        "Preencha todos os campos obrigatórios! Campo: Nome, Ordem"
      );
      return;
    }
    for (const key in props?.contentModal) {
      if (
        props?.contentModal[key] !== null &&
        props?.contentModal[key] !== undefined
      ) {
        dataAux[key] = props?.contentModal[key];
      }
    }
    dataAux.index = uniKey();
    if (removerCapa && !capaImage) dataAux.remover_capa = true;
    if (removerThumb && !thumbImage) dataAux.remover_thumb = true;
    const newData = JSON.stringify(dataAux);
    formData.append("newData", newData);
    if (capaImage !== null) {
      formData.append("dca_capa", capaImage);
    }
    if (thumbImage !== null) {
      formData.append("dca_thumb", thumbImage);
    }
    await requestWithImage(
      "/dossie_capitulos/updateCapitulo/" + props?.contentModal?.dca_id,
      {
        method: "PUT",
        body: formData,
      }
    )
      .then((res) => {
        if (res?.err) throw res.err;
        toast.success("Capítulo salvo com sucesso!");
        aoSalvar();
      })
      .catch((err) => {
        console.log(err);
        toast.error("Erro ao Salvar Dossiê!");
      });
  };

  return (
    <>
      <Drawer
        title={
          props?.contentModal?.dca_id
            ? "Editar Capítulo"
            : "Adicionar Novo Capítulo"
        }
        open={props.isAddOpen}
        onClose={props.onRequestClose}
        extra={
          <Button
            type="primary"
            onClick={(el) => {
              !props?.contentModal?.dca_id
                ? saveData()
                : updateData();
            }}
          >
            Salvar
          </Button>
        }
      >
        <Form layout="vertical">
          <Form.Item label={"Título"}>
            <Input
              value={props.contentModal.dca_nome}
              onChange={(e) =>
                props.setContentModal({
                  ...props.contentModal,
                  dca_nome: e.target.value,
                })
              }
            />
          </Form.Item>
          <Form.Item label={"Descrição"}>
            <TextArea
              value={props.contentModal.dca_desc}
              onChange={(e) =>
                props.setContentModal({
                  ...props.contentModal,
                  dca_desc: e.target.value,
                })
              }
            />
          </Form.Item>
          <CampoImagem
            rotulo="Capa"
            proporcao="3 / 2"
            atual={props?.contentModal?.dca_capa}
            arquivo={capaImage}
            removida={removerCapa}
            chaveInput={`capa-${versaoInputs}`}
            onArquivo={(f) => {
              setCapaImage(f);
              setRemoverCapa(false);
            }}
            onRemover={() => {
              if (capaImage) {
                setCapaImage(null);
                setVersaoInputs((v) => v + 1);
              } else {
                setRemoverCapa(true);
              }
            }}
            onDesfazer={() => setRemoverCapa(false)}
          />
          <CampoImagem
            rotulo="Thumbnail"
            proporcao="16 / 9"
            atual={props?.contentModal?.dca_thumb}
            arquivo={thumbImage}
            removida={removerThumb}
            chaveInput={`thumb-${versaoInputs}`}
            onArquivo={(f) => {
              setThumbImage(f);
              setRemoverThumb(false);
            }}
            onRemover={() => {
              if (thumbImage) {
                setThumbImage(null);
                setVersaoInputs((v) => v + 1);
              } else {
                setRemoverThumb(true);
              }
            }}
            onDesfazer={() => setRemoverThumb(false)}
          />
          <Form.Item label={"Ordem (Ordem numerica 1, 2, 3 ...)"}>
            <Input
              value={props.contentModal.dca_ordem}
              onChange={(e) =>
                props.setContentModal({
                  ...props.contentModal,
                  dca_ordem: e.target.value.trim(),
                })
              }
            />
          </Form.Item>
          <Form.Item label={"Link do video"}>
            <Input
              value={props.contentModal.dca_cdn}
              onChange={(e) =>
                props.setContentModal({
                  ...props.contentModal,
                  dca_cdn: e.target.value,
                })
              }
              type="text"
            />
            </Form.Item>
            <Form.Item label={"Link Backup (Deixar em branco ou 0)"}>
            <Input
              value={props.contentModal.dca_video}
              onChange={(e) =>
                props.setContentModal({
                  ...props.contentModal,
                  dca_video: e.target.value,
                })
              }
              type="text"
            />
          </Form.Item>
          <Form.Item label={"Ativo"}>
            <Switch
              onChange={(e) =>
                props.setContentModal({ ...props.contentModal, dca_ativo: e })
              }
              checked={props.contentModal.dca_ativo}
            />
          </Form.Item>
          <Form.Item label={"Aberto"}>
            <Switch
              onChange={(e) =>
                props.setContentModal({
                  ...props.contentModal,
                  dca_aberto: e,
                })
              }
              checked={props.contentModal.dca_aberto}
            />
          </Form.Item>
        </Form>
      </Drawer>
    </>
  );
}

export default ModalDossieCapitulo;
